<!-- 应用组件 -->
<template>
    <div class="container">
        <template v-if="$route.path === '/admin/assembly'">
            <div
                v-for="(item, index) in app_data"
                :key="index"
                class="content mb24"
                :style="`border-left-color: ${item.font_color};`"
            >
                <div class="title-container">
                    {{ item.name }}
                </div>
                <div class="flex-wrap mt24 position-relative">
                    <div
                        v-for="(e, i) in item.list"
                        :key="i"
                        class="card"
                        @click="goJump(e)"
                        :style="`background: ${item.bg_color};`"
                    >
                        <img
                            v-if="e.icon"
                            :src="e.show_icon"
                            class="card-icon"
                        />
                        <div class="display-flex flex-column">
                            <div class="card-title card-txt">{{ e.name }}</div>
                            <div v-if="e.desc" class="card-txt">
                                {{ e.desc }}
                            </div>
                        </div>
                        <div v-if="!e.is_permission" class="card-mask"></div>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <router-view></router-view>
        </template>
    </div>
</template> 

<script>
import { apps_list } from "@/api/index";
export default {
    data() {
        return {
            app_data: [],
        };
    },
    mounted() {
        this.getAppsList();
    },
    methods: {
        getAppsList() {
            apps_list().then((res) => {
                this.app_data = res.data;
            });
        },
        goJump(e) {
            if (!e.is_permission) {
                this.$router.push({
                    path: `/admin/assembly/info?title=${e.name}&id=${e.id}&apps_id=${e.apps_id}`,
                });
            } else {
                if (e.apps_id == 1) {
                    // 微信关注扫码领红包
                    this.$router.push({ path: "/admin/assembly/wxpacket" });
                    // this.$router.push({ path: "/admin/assembly/integral" });
                    return
                }
                this.$router.push({
                    path: `/admin/assembly/info?title=${e.name}&id=${e.id}&apps_id=${e.apps_id}`,
                });
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 8px;
}
/* 标题区块 */
.title-container {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1f2937;
}
/* 左边框颜色（使用标题色块颜色） */
.content {
    border-left: 4px solid #2563eb;
}
.title {
    width: 4px;
    height: 20px;
    border-radius: 4px;
    margin-right: 10px;
}
/* 卡片列表 */
.flex-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding-top: 16px;
}
.position-relative {
    position: relative;
}
/* 卡片样式 */
.card {
    display: flex;
    align-items: center;
    padding: 16px;
    min-width: 280px;
    width: 280px;
    height: 88px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #747b95;
    cursor: pointer;
    transition: all 0.2s ease;
}
.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.card-icon {
    margin-right: 14px;
    width: 48px;
    height: 48px;
    border-radius: 10px;
    object-fit: cover;
}
.display-flex {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}
.card-title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1f2937;
    margin-bottom: 4px;
}
.card-txt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    display: inline-block;
    font-size: 13px;
    color: #6b7280;
}
.flex-column {
    flex-direction: column !important;
}
/* 无权限遮罩 */
.card-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background-color: rgba(147, 146, 146, 0.5);
    z-index: 10;
    cursor: pointer;
}
</style>